import { render, staticRenderFns } from "./CampaignCreativesDailyPage.vue?vue&type=template&id=24c60f39&"
import script from "./CampaignCreativesDailyPage.vue?vue&type=script&lang=js&"
export * from "./CampaignCreativesDailyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports